import type { RouteRecordRaw } from 'vue-router';

export const salesRoutes: RouteRecordRaw[] = [
  {
    path: 'sales',
    name: 'sales',
    component: () => import('./pages/SalesHistoryPage.vue'),
    meta: { title: 'Sales', requiresAuth: true, permission: 'view_sales' },
  },
  {
    path: 'sales/:id',
    name: 'sales.show',
    component: () => import('./pages/SaleDetailPage.vue'),
    meta: { title: 'Sale', requiresAuth: true, permission: 'view_sales' },
  },
];
